import { useMutation } from '@tanstack/react-query';
import {
  invalidateWaitlistSettings,
  updateCancellationWaitlistSettings,
} from '../../services/cancellation-waitlist';
import { UpdateCancellationWaitlistSettingsPayload } from '../../types/cancellation-waitlist';

interface Options {
  onSuccess?: () => void | Promise<void>;
  onError?: (message: string) => void | Promise<void>;
}

function useUpdateCancellationWaitlistSettings({
  onSuccess,
  onError,
}: Options = {}) {
  return useMutation({
    mutationFn: (payload: UpdateCancellationWaitlistSettingsPayload) =>
      updateCancellationWaitlistSettings(payload),
    onSuccess: async () => {
      await invalidateWaitlistSettings();
      await onSuccess?.();
    },
    onError: (error: Error) => {
      onError?.(error.message || 'Failed to update waitlist settings');
    },
  });
}

export default useUpdateCancellationWaitlistSettings;
